import 'regenerator-runtime/runtime';
import { call, select, takeLatest } from 'redux-saga/effects';
import {
  GlobalActions,
  GlobalPut,
  QuoteDbToolbarPayload,
} from '@ps20-frontend/shop-integration-redux';
import { Feature, VersicherungsNehmerOuote } from '@ps20/bff-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';
import { selectFeatureToggle } from '@ps20-frontend/selector';
import { Versicherungsnehmer } from '../interfaces/versicherungsnehmer';
import { IAppState } from '../toolbarState';

export function* quoteDbSaga() {
  yield takeLatest(
    GlobalActions.QUOTEDB_TOOLBAR_DATA_REQUESTED,
    safeSaga(getQuoteDbData, App.SHOP_TOOLBAR),
  );
}

export function* getQuoteDbData() {
  const state: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();
  const quoteDbPayload: QuoteDbToolbarPayload = {
    gesamtpreis: state.gesamtpreis,
    rbd: state.rbd.map(rbd => ({
      appId: rbd.appId,
      angebotsId: rbd.angebotsId,
      max: rbd.rbd_max,
      aktuell: rbd.rbd_aktuell,
    })),
    treuebonus: state.treuebonus.map(treue => Object.assign({}, treue)),
    zahlungsart: state.zahlungsoptionen.zahlungsart,
    zahlweise: state.zahlungsoptionen.zahlungsweise,
    versicherungsNehmer: state.versicherungsnehmer
      ? mapToVersicherungsnehmerQuote(state.versicherungsnehmer)
      : undefined,
    isAssekuranztarif: state.versicherungsnehmer
      ? state.versicherungsnehmer.isAssekuranztarif
      : undefined,
    vorteilsRabatte: state.vorteilsrabatt?.produkte?.map(vorteil => ({
      appId: vorteil.appId,
      kennungNeuesRabattkonzept: selectFeatureToggle(state, Feature.VORTEILSRABATT),
      angebotsId: vorteil.angebotsId || undefined,
      nachlassVorteilStartgutschriftPrz: vorteil.startgutschriftPrz,
      nachlassVorteilBelastfakNiedrig: vorteil.belastfakNiedrig,
      nachlassVorteilBelastfakHoch: vorteil.belastfakHoch,
      nachlassVorteilKipp: vorteil.kipp,
      cpStern: vorteil.cpSternBausteine,
      nachlassVorteilMax: vorteil.max,
      nachlassVorteil: vorteil.rabattInProzent,
    })),
  };

  yield call(globalPut.put, new GlobalActions().quoteDBDataToolbarGenerated(quoteDbPayload));
}

function mapToVersicherungsnehmerQuote(
  versicherungsnehmer: Versicherungsnehmer,
): VersicherungsNehmerOuote {
  return {
    adresse: {
      strasse: versicherungsnehmer.adresse.strasse,
      ort: versicherungsnehmer.adresse.ort,
      plz: versicherungsnehmer.adresse.plz,
      hausnummer: versicherungsnehmer.adresse.hausnummer,
    },
    geburtsdatum: versicherungsnehmer.geburtsdatum.split('.').reverse().join('-'),
    vorname: versicherungsnehmer.vorname,
    nachname: versicherungsnehmer.nachname,
    name: versicherungsnehmer.nachname,
    firmenname: versicherungsnehmer.firmenname,
    businessForm: versicherungsnehmer.businessForm,
    juristisch: versicherungsnehmer.juristisch,
    anrede: versicherungsnehmer.anrede,
  };
}
